export interface EyeIconProps {
  size?: number;
  className?: string;
}

/**
 * Eye Icon - Show password visibility
 *
 * Used in password input fields to toggle visibility
 */
export const EyeIcon = ({ size = 16, className = "" }: EyeIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M1.5 8C1.5 8 3.5 4 8 4C12.5 4 14.5 8 14.5 8C14.5 8 12.5 12 8 12C3.5 12 1.5 8 1.5 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="8"
        cy="8"
        r="2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

EyeIcon.displayName = "EyeIcon";
